import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import './Screen.scss';
import { NavLinkProp } from '../../types.ts';

interface ScreenProps {
  navigationLinks?: NavLinkProp[];
  useDealerBranding?: boolean;
}

const Screen = ({ navigationLinks, useDealerBranding = false }: ScreenProps) => {
  const portal = () => {
    const port = window.location.port;

    switch (port) {
      case '5100':
        return 'Consumer Portal';
      case '5200':
        return 'Admin Portal';
      case '5300':
        return 'Dealer Portal';
    }
  };
  return (
    <>
      {import.meta.env.MODE === 'development' && (
        <div className="screen-mode">
          <span>Development Mode</span>
          <span>{portal()}</span>
        </div>
      )}
      <Header navigationLinks={navigationLinks} useDealerBranding={useDealerBranding} />
      <div className="Screen">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default Screen;
